var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLessonLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.714 7.167h-.643V5.292c0-2.183-1.826-3.959-4.071-3.959-2.245 0-4.071 1.776-4.071 3.959v1.875h-.643c-.71 0-1.286.56-1.286 1.25v5c0 .69.576 1.25 1.286 1.25h9.428c.71 0 1.286-.56 1.286-1.25v-5c0-.69-.576-1.25-1.286-1.25zM10 7.333H6v-2c0-1.102.897-2 2-2s2 .898 2 2v2z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLessonLock);
export default __webpack_public_path__ + "static/media/icon-lesson-lock.1027463a.svg";
export { ForwardRef as ReactComponent };